import { render } from "./EditionSwitcher.vue?vue&type=template&id=4bf92ca1&scoped=true"
import script from "./EditionSwitcher.vue?vue&type=script&lang=js"
export * from "./EditionSwitcher.vue?vue&type=script&lang=js"

import "./EditionSwitcher.vue?vue&type=style&index=0&id=4bf92ca1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bf92ca1"]])

export default __exports__